export interface TechnicianTrade {
  id: number;
  label: string;
  /** This is the Gewerk of the Auftrag being planned. */
  matched: boolean;
}

/**
 * The trade chips of one Handwerker: every Gewerk they cover, the one being planned first.
 *
 * A trade whose label is not known (the lookup is still loading, or the id no longer exists in
 * Immotion) is left out rather than shown as a bare number — a number tells the dispatcher nothing.
 * Order inside each group is the profile's own.
 */
export function technicianTrades(
  trades: number[],
  labels: ReadonlyMap<number, string>,
  gewerkId: number | null,
): TechnicianTrade[] {
  const known = trades.flatMap((id) => {
    const label = labels.get(id);
    return label ? [{ id, label, matched: id === gewerkId }] : [];
  });

  return [...known.filter((t) => t.matched), ...known.filter((t) => !t.matched)];
}
